import type {PinRegion} from '../../types';

type RegionSummaryProps = {
  region?: PinRegion;
};

const RegionSummary: React.FC<RegionSummaryProps> = ({region}) => {
  return (
    <div className="flex overflow-x-auto p-2.5">
      <div className="flex flex-1 flex-col items-center justify-center gap-2.5 border-l border-gray-03 p-2.5">
        <span className="text-body-sm text-gray-07">سفارش‌های شما</span>
        <span className="text-body-sm text-neutral-fg">
          <span className="text-body-sm-emphasis">{region?.order_count ?? 0} سفارش</span>
          {' / '}
          <span className="text-body-xs">در روز</span>
        </span>
      </div>
      <div className="flex flex-1 flex-col items-center justify-center gap-2.5 p-2.5">
        <span className="text-body-sm text-gray-07">جایگاه در محدوده</span>
        <span className="text-body-sm-emphasis text-neutral-fg">{region?.rank ?? ''}</span>
      </div>
    </div>
  );
};

export default RegionSummary;
